import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateDepartment as apiUpdateDepartment } from "../../api/apiDepartments";
import { toast } from "react-hot-toast";
import getErrorMessageFromAxiosError from "../../utils/parseError";

/**
 * Hook لتحديث قسم موجود
 */
export function useUpdateDepartment() {
    const queryClient = useQueryClient();

    const {
        mutate: updateDepartment,
        isPending: isUpdating,
        error,
    } = useMutation({
        mutationFn: ({ id, data }) => apiUpdateDepartment(id, data),
        onSuccess: (response) => {
            toast.success(response.message || 'Department updated successfully');
            queryClient.invalidateQueries({
                queryKey: ["departments"],
            });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Failed to update department");
            toast.error(msg);
        },
    });

    return { updateDepartment, isUpdating, error };
}
